import PropTypes from 'prop-types';
import React from 'react';

class Loader extends React.Component {
    render() {
        return (
            <span className={`loader ${this.props.type ? this.props.type : ''}`}>
                <span className="loader-spinner || animate-spin"></span>
                <span className="loader-text">Loading..</span>
            </span>
        );
    }
}

Loader.propTypes = {
    type: PropTypes.string
};

export default Loader;
